export default {
  table: {
    columns: 'Stolpci'
  }
};
